(function(){
	if(typeof APPS === "undefined"){ APPS ={}; }
	APPS.resources = {};
	
	// Router//
	
	var Router = Marionette.AppRouter.extend({
		appRoutes: {
			"resources":"resources"
		}
	})
	
	// API : called by Router//
	var API = {
		resources:function(){
			APPS.resources.page.show()
		}
	}
	
	APP.on("before:start", function(){
		new Router({
			controller: API
		})
	})
})();


